<template>
</template>

<script>
export default {
  name: 'wap-pay',
  props: {
    applyResult: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    payMethod: {
      type: String,
      default: ''
    }
  },
  mounted() {
    window.location.replace(this.applyResult)
  }
}
</script>
